export interface ClearToApply {
    bankrupt: string;
    lifeTimeAllowance: string;
    pensionPolicy: string;
    guaranteedStartDate: string;
    ltaProtection: string;
    ltaProtectionType: string;
    riskAndStaticQuestion: any[];
}
